// src/api/uploadEvidence.ts
import { supabase } from "@/integrations/supabase/client";

/**
 * Upload a single file via the hardened upload-evidence Edge Function.
 * ACTION 2: the function returns an evidence_id only — never a URL. Reads must
 * go through `evidence-access` (see src/lib/evidenceAccess.ts).
 */
export async function uploadEvidenceFile(params: {
  assessmentId: string;
  questionId: number;
  findingId?: string;
  file: File;
  title?: string;
}): Promise<{ evidenceId: string; filename: string; mime: string; byteSize: number }> {
  const { assessmentId, questionId, findingId, file, title } = params;

  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error("User not authenticated");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("assessment_id", assessmentId);
  formData.append("question_id", String(questionId));
  if (findingId) formData.append("finding_id", findingId);
  if (title) formData.append("title", title);

  const { data, error } = await supabase.functions.invoke("upload-evidence", {
    body: formData,
  });

  if (error || !data?.success || !data?.evidence_id) {
    throw new Error(data?.error || error?.message || "Upload failed");
  }

  return {
    evidenceId: data.evidence_id,
    filename: data.filename,
    mime: data.mime,
    byteSize: data.byte_size,
  };
}
